module.exports = function() {
  return new Worker(__webpack_public_path__ + "11c518685b9abd46b13b.worker.js");
};